export default __webpack_public_path__ + "static/ProValue_4@mob-6e55909029201d6c9750d8e85a2bb2be.webp";